<template>
    <div class="modal fade" :id="id" data-bs-backdrop="static"
        aria-labelledby="image-edit-modal" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header border-bottom-0 pb-0">
                    <div class="w-100">
                        <button type="button" class="btn btn-white float-end close-modal"
                            data-bs-dismiss="modal" data-bs-toggle="tooltip" title="Close">
                            <img class="icon me-0" src="/img/icons/avid-icons/close.svg" alt="">
                        </button>
                        <h3 class="mt-2 text-center">Edit Profile Image</h3>
                        <p class="text-center text-muted">Upload a new profile image or remove the current one</p>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="row justify-content-center">
                        <div class="col-md-8">
                            <div class="image-dropzone-container">
                                <ImageDropzone
                                    v-model="imageUrl"
                                    :id="'modal-image-dropzone'"
                                    :if_thumbnail="false"
                                    :client-url="clientUrl"
                                    @update:modelValue="handleImageUpdate"
                                    ref="imageDropzone"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="w-100 d-flex justify-content-end">
                        <button class="btn btn-primary" @click="saveImage" :disabled="working">
                            <span v-if="working">
                                <div class="d-inline-block spinner-border spinner-border-sm me-2" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                                Saving...
                            </span>
                            <span v-else>
                                <img class="icon me-2" src="/img/icons/avid-icons/save.svg" alt="">Save
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import ImageDropzone from './ImageDropzone.vue';
import { useNotifications } from '../../composables/useNotifications';

export default defineComponent({
    name: 'ImageEditModal',
    components: {
        ImageDropzone
    },
    setup() {
        const { showNotification } = useNotifications();
        return {
            showNotification
        };
    },
    props: {
        id: {
            type: String,
            default: 'image-edit-modal'
        },
        currentImage: {
            type: String,
            default: ''
        },
        clientUrl: {
            type: String,
            default: null
        }
    },
    emits: ['image-updated'],
    data() {
        return {
            imageUrl: '',
            working: false
        };
    },
    watch: {
        currentImage: {
            immediate: true,
            handler(newVal) {
                this.imageUrl = newVal || '';
            }
        }
    },
    methods: {
        handleImageUpdate(value) {
            this.imageUrl = value;
        },
        async saveImage() {
            this.working = true;
            
            try {
                // Emit the updated image URL to parent component
                this.$emit('image-updated', this.imageUrl);
                
                // Close the modal
                const myModalEl = document.getElementById(this.id);
                const modal = window.bootstrap.Modal.getInstance(myModalEl);
                if (modal) {
                    modal.hide();
                }
                
                // Show success message
                this.showNotification({
                    text: 'Your profile image was successfully updated!'
                });
                
            } catch (error) {
                console.error('Error saving image:', error);
                
                // Show error message
                this.showNotification({
                    text: 'Failed to update your profile image. Please try again.',
                    type: 'error'
                });
            } finally {
                this.working = false;
            }
        }
    }
});
</script>
